
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rates/[id]",
      function () {
        return require("private-next-pages/rates/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rates/[id]"])
      });
    }
  